
angular = require('angular')
pkg = angular.module('cdms.tag', [require('angular-ui-router')])  
  .factory('Tag', require("./tag"))
  .directive('tagSelector', require("./selector"))
  
module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/tag/index.coffee